module.exports = __webpack_public_path__ + "static/media/icon_estoque.24ec10c5.png";